var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 378,
    height: 22,
    viewBox: "0 0 378 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_3369)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 -14 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 -3.10742 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 7.78516 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 18.6777 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 29.5703 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 40.4619 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 51.3545 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 62.2471 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 73.1396 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 84.0322 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 94.9248 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 105.817 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 116.71 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 127.603 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 138.495 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 149.387 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 160.279 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 171.172 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 182.064 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 192.957 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 203.85 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 214.742 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 225.635 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 236.527 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 247.419 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 258.312 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 269.204 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 280.097 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 290.989 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 301.882 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 312.774 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 323.667 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 334.56 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 345.452 23.5903)",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 31.5118,
    y2: -0.5,
    transform: "matrix(0.663005 -0.748615 0.687137 0.726528 356.345 23.5903)",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_3369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 391.237,
    height: 23.5902,
    fill: "white",
    transform: "translate(-14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBottom);
export default __webpack_public_path__ + "static/media/modal-bottom.26ad5b53bb22112e2239b1b4b6158966.svg";
export { ForwardRef as ReactComponent };